import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { DivisionSummaryReportSchemaObject } from '../DivisionSummaryReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { isNumber } from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';

const screenCode = "DIVISIONSUMMARYREPORTMPL";

export function DivisionSummaryMPLListing(props) {

    const componentRef = useRef();
    const [divisions, setDivisions] = useState([]);
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);

    const [divisionSummaryDetails, setDivisionSummaryDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        searchDate: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        estateID: "0",
        division: "0",
        searchDate: "",
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(DivisionSummaryReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "fieldName", "pluckingOriginalWeight", "pluckingCheckrollWeight",
        "fieldNoOfBags","fieldActualAmount", "fieldGrossWeight", "fieldNetWeight",
        "recievingFactory", "factoryNoOfBags", "factoryActualAmount", "factoryGross", "factoryMoistureDeduction", "factoryNetWight"]
    const [dynamicContentRowNames, setDynamicContentRowNames] = useState([]);
    const [avialablePluckingDeductions, setAvialablePluckingDeductions] = useState([]);
    let availableDeductionCount = 0;
    let pluckingDeductions = [];
    const [csvHeaders, setCsvHeaders] = useState([
        { label: "Collection Point", value: "collectionPointName" },
        { label: "Field Name", value: "fieldName" },
        { label: "Plucking Original Weight", value: "pluckingOriginalWeight" },
        { label: "Plucking Checkroll Weight", value: "pluckingCheckrollWeight" },
        { label: "Field Actual Amount", value: "fieldActualAmount" },
        { label: "Field Gross Weight", value: "fieldGrossWeight" },
        { label: "Field Net Weight", value: "fieldNetWeight" },
        { label: "Field No Of Bags", value: "fieldNoOfBags" },
        { label: "Recieving Factory", value: "recievingFactory" },
        { label: "Factory Actual Amount", value: "factoryActualAmount" },
        { label: "Factory Gross Weight", value: "factoryGross" },
        { label: "Factory No Of Bags", value: "factoryNoOfBags" },
        { label: "Factory Deduction", value: "factoryMoistureDeduction" },
        { label: "Factory Net Weight", value: "factoryNetWight" },
    ]);

    const [totalCollections, setTotalCollections] = useState({
        pluckingOriginalWeight: 0,
        pluckingMoistureDeduction: 0,
        pluckingCheckrollWeight: 0,
        fieldActualAmount: 0,
        fieldGrossWeight: 0,
        fieldNetWeight: 0,
        fieldNoOfBags: 0,
        factoryActualAmount: 0,
        factoryGross: 0,
        factoryNoOfBags: 0,
        factoryMoistureDeduction: 0,
        factoryNetWight: 0
    });
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [divisionSummaryDetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown()
        )
    }, [divisionSummaryDetails.estateID])

    function handleGroupChange(target) {
        validateInputs(target);

        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            groupID: target.value,
            estateID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            estateID: target.value

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            divisionID: target.value

        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            searchDate: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DivisionSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDIVISIONSUMMARYREPORTMPL');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(divisionSummaryDetails.groupID);
        setEstates(data);
    }
    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(divisionSummaryDetails.estateID);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);
        setButtonHide(true);

        const errorMessages = validate(schema, divisionSummaryDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var copyOftotalCollections = totalCollections;
        var csvHeadersCopy = csvHeaders;

        for (const key in copyOftotalCollections) {
            copyOftotalCollections[key] = 0;
        }

        setTotalCollections(copyOftotalCollections);

        getSelectedDropdownValuesForReport(divisionSummaryDetails);

        const result = await services.getDivisionSummaryReportMPLData(divisionSummaryDetails);

        var pluckingResult = result.pluckingResult;
        var factoryResult = result.factoryResult;
        var fieldResult = result.fieldResult;
        var deductions = result.deductions;

        var joinedResult = [];
        var finalResult = [];

        var mergedPluckingResult = mergePluckingData(pluckingResult)
        var joinedArrays = _.merge(_.keyBy(mergedPluckingResult, 'fieldID'), _.keyBy(factoryResult, 'fieldID'), _.keyBy(fieldResult, 'fieldID'));
        Object.keys(joinedArrays).forEach(x => joinedResult.push(joinedArrays[x]));
        joinedResult.forEach(x => {
            finalResult.push(x);
        });

        var rowNames = createDynmaicColumnNmaes(deductions, finalResult);

        finalResult.forEach(x => {

            copyOftotalCollections.factoryActualAmount += (x.factoryActualAmount === undefined) ? 0 : x.factoryActualAmount;
            copyOftotalCollections.factoryGross += (x.factoryGross === undefined) ? 0 : x.factoryGross;
            copyOftotalCollections.factoryMoistureDeduction += (x.factoryMoistureDeduction === undefined) ? 0 : x.factoryMoistureDeduction;
            copyOftotalCollections.factoryNetWight += (x.factoryNetWight === undefined) ? 0 : x.factoryNetWight;
            copyOftotalCollections.factoryNoOfBags += (x.factoryNoOfBags === undefined) ? 0 : x.factoryNoOfBags;
            copyOftotalCollections.fieldActualAmount += (x.fieldActualAmount === undefined) ? 0 : x.fieldActualAmount;
            copyOftotalCollections.fieldGrossWeight += (x.fieldGrossWeight === undefined) ? 0 : x.fieldGrossWeight;
            copyOftotalCollections.fieldNetWeight += (x.fieldNetWeight === undefined) ? 0 : x.fieldNetWeight;
            copyOftotalCollections.fieldNoOfBags += (x.fieldNoOfBags === undefined) ? 0 : x.fieldNoOfBags;
            copyOftotalCollections.pluckingCheckrollWeight += (x.pluckingCheckrollWeight === undefined) ? 0 : x.pluckingCheckrollWeight;
            pluckingDeductions.forEach(y => {
                if (copyOftotalCollections[y] === undefined) {
                    if (x[y] === undefined)
                        copyOftotalCollections[y] = 0;
                    else {
                        copyOftotalCollections[y] = x[y];
                    }
                } else {
                    if (x[y] !== undefined)
                        copyOftotalCollections[y] += x[y];
                }
            });
            copyOftotalCollections.pluckingOriginalWeight += (x.pluckingOriginalWeight === undefined) ? 0 : x.pluckingOriginalWeight;

            for (const key in x) {
                if (isNumber(x[key]) && (key !== 'fieldNoOfBags' && key !== 'factoryNoOfBags')) {
                    x[key] = x[key];
                }
            }
        });

        pluckingDeductions.forEach((x, i) => {
            csvHeadersCopy.splice((4 + i), 0, { label: x, value: x },)
        })

        for (const key in copyOftotalCollections) {
            if (key !== 'fieldNoOfBags' && key !== 'factoryNoOfBags') {
                copyOftotalCollections[key] = copyOftotalCollections[key]
            }
        }

        finalResult.sort((a, b) => (a.collectionPointID > b.collectionPointID) ? 1 : -1)
        divisionWiseData(finalResult)
        createCsvFile(finalResult, copyOftotalCollections);

        setTotalCollections(copyOftotalCollections);
        setIsTableHide(false);
        destroyDataTable();
        //setReportData(finalResult);
        setIsReportButtonsEnabled(true);
        setButtonHide(false);
        createDataTable(rowNames, ['#example3', '#pdfTable']);
    }

    function createFile() {
        var settings = {
            sheetName: 'Divison Summary Report (MPL)',
            fileName: 'DivisonSummaryReportMPL',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Group :" + groups[divisionSummaryDetails.groupID],
            fieldName: "Estate : " + estates[divisionSummaryDetails.estateID],
            pluckingCheckrollWeight: "Search Date : " + divisionSummaryDetails.searchDate,
        }
        var newRow2 = {
            collectionPointName: "Group :" + divisions[divisionSummaryDetails.divisionID]
        }
        copyOfCsv.push({}, {}, newRow1, newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function createCsvFile(data, total) {
        var res = [];
        data.forEach(x => {
            var newrRecord = x;
            pluckingDeductions.forEach(y => {
                newrRecord[y] = x[y]
            })
            res.push(newrRecord);
        });

        total.collectionPointName = "Total";
        res.splice((data.length + 1), 0, total)
        setCsvData(res);
    }

    function createDynmaicColumnNmaes(deductions, finalResult) {
        var count = 3;
        var deductionsInReport = [];
        var rowNames = contentRowNames;

        deductions.forEach(x => {
            finalResult.forEach(y => {
                if (y[x.deductionTypeName] !== undefined) {
                    if (!deductionsInReport.includes(x.deductionTypeName))
                        deductionsInReport.push(x.deductionTypeName);
                }
            });
        });

        deductionsInReport.forEach(x => {
            rowNames.splice(count, 0, x);
            count++;
        })

        setDynamicContentRowNames(rowNames);
        setAvialablePluckingDeductions(deductionsInReport);
        availableDeductionCount = deductionsInReport.length;
        pluckingDeductions = deductionsInReport;
        return rowNames;
    }

    function mergePluckingData(pluckingResult) {
        var mergedPluckingResult = [];

        pluckingResult.forEach(x => {

            var isPluckingDataExist = mergedPluckingResult.find(y => y.fieldID === x.fieldID)

            if (isPluckingDataExist) {
                isPluckingDataExist.pluckingOriginalWeight += x.pluckingOriginalWeight;
                isPluckingDataExist.pluckingCheckrollWeight += x.pluckingCheckrollWeight;
                if (x.deductionTypeName !== null)
                    isPluckingDataExist[x.deductionTypeName] = x.deductionAmount;

            } else {
                if (x.deductionTypeName !== null)
                    x[x.deductionTypeName] = x.deductionAmount;

                delete x.deductionTypeName;
                delete x.deductionAmount;
                delete x.deductionTemplateID;
                mergedPluckingResult.push(x);
            }
        });

        return mergedPluckingResult;
    }

    function divisionWiseData(data) {
        var mergedPluckingResult = [];
        data.forEach(x => {
            var isExist = mergedPluckingResult.find(y =>
                parseInt(y.collectionPointID) === parseInt(x.collectionPointID));

            if (isExist) {
                isExist.isBold = true;
                isExist.collectionPointID = x.collectionPointID.toString();
                isExist.collectionPointName = 'Total for ' + x.collectionPointName;
                isExist.pluckingOriginalWeight += (x.pluckingOriginalWeight == undefined) ? 0 : x.pluckingOriginalWeight;
                isExist.pluckingCheckrollWeight += (x.pluckingCheckrollWeight == undefined) ? 0 : x.pluckingCheckrollWeight;
                isExist.fieldActualAmount += (x.fieldActualAmount == undefined) ? 0 : x.fieldActualAmount;
                isExist.fieldGrossWeight += (x.fieldGrossWeight == undefined) ? 0 : x.fieldGrossWeight;
                isExist.fieldNetWeight += (x.fieldNetWeight == undefined) ? 0 : x.fieldNetWeight;
                isExist.fieldNoOfBags += (x.fieldNoOfBags == undefined) ? 0 : x.fieldNoOfBags;
                isExist.factoryNoOfBags += (x.factoryNoOfBags == undefined) ? 0 : x.factoryNoOfBags;
                isExist.factoryActualAmount += (x.factoryActualAmount == undefined) ? 0 : x.factoryActualAmount;
                isExist.factoryGross += (x.factoryGross == undefined) ? 0 : x.factoryGross;
                isExist.factoryMoistureDeduction += (x.factoryMoistureDeduction == undefined) ? 0 : x.factoryMoistureDeduction;
                isExist.factoryNetWight += (x.factoryNetWight == undefined) ? 0 : x.factoryNetWight;
            }
            else {
                mergedPluckingResult.push({
                    isBold: true,
                    collectionPointID: x.collectionPointID.toString(),
                    collectionPointName: 'Total for ' + x.collectionPointName,
                    pluckingOriginalWeight: (x.pluckingOriginalWeight == undefined) ? 0 : x.pluckingOriginalWeight,
                    pluckingCheckrollWeight: (x.pluckingCheckrollWeight == undefined) ? 0 : x.pluckingCheckrollWeight,
                    fieldActualAmount : (x.fieldActualAmount == undefined) ? 0 : x.fieldActualAmount,
                    fieldGrossWeight: (x.fieldGrossWeight == undefined) ? 0 : x.fieldGrossWeight,
                    fieldNetWeight: (x.fieldNetWeight == undefined) ? 0 : x.fieldNetWeight,
                    fieldNoOfBags: (x.fieldNoOfBags == undefined) ? 0 : x.fieldNoOfBags,
                    factoryNoOfBags: (x.factoryNoOfBags == undefined) ? 0 : x.factoryNoOfBags,
                    factoryActualAmount: (x.factoryActualAmount == undefined) ? 0 : x.factoryActualAmount,
                    factoryGross: (x.factoryGross == undefined) ? 0 : x.factoryGross,
                    factoryMoistureDeduction: (x.factoryMoistureDeduction == undefined) ? 0 : x.factoryMoistureDeduction,
                    factoryNetWight: (x.factoryNetWight == undefined) ? 0 : x.factoryNetWight
                });
            }

        });
        var result = arrayMerge(data, mergedPluckingResult)
        setReportData(result);
    }

    function arrayMerge(inputArray, totalDataArray) {
        let mainArray = []
        for (const iterator of totalDataArray) {
            let tempArray = [...inputArray]
            let filteredArray = tempArray.filter(e => e.collectionPointID.toString() === iterator.collectionPointID.toString())
            filteredArray.push(iterator)
            mainArray = mainArray.concat(filteredArray)
        }
        return mainArray;
    }

    function destroyDataTable() {
        $('#example3').DataTable().destroy();
    }

    function createDataTable(rowNames, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#pdfTable' ? true : false,
                searching: x === '#pdfTable' ? false : true,
                paging: x === '#pdfTable' ? false : true,
                order: [[0, 'asc']],
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < rowNames.length; ++i) {
                            if (i !== 0 || i !== 1 || i !== (8 + availableDeductionCount)) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        return a + b * 1;
                                    }, 0);
                            } else {
                                dynamicCountVariable[i] = NaN;
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < rowNames.length; ++i) {
                            if (isNaN(dynamicCountVariable[i])) {
                                if (i !== 0)
                                    rowData += '<td/>';
                            }
                            else {
                                rowData += '<td style="text-align:right"><b>' + parseInt(dynamicCountVariable[i]) + '</b></td>';
                            }
                        }

                        return $('<tr/>')
                            .append('<td><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 0
                }
            }).columns.adjust();
        })
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setDivisionSummaryDetails({
            ...divisionSummaryDetails,
            searchDate: ""
        });
        setIsTableHide(true);
        setErrors("");
        setIsReportButtonsEnabled(false);
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            searchDate: searchForm.searchDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Division Summary Report (MPL)"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={divisionSummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={divisionSummaryDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={divisionSummaryDetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-4">
                                        <InputLabel shrink id="searchDate">Search Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, divisionSummaryDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {reportData.length != 0 ?
                                <div >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="simple table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                                                    <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                                                        Field
                                                                    </TableCell>
                                                                    <TableCell align="center" colSpan={2 + avialablePluckingDeductions.length} style={{ background: "lightblue", fontWeight: "bold" }}>
                                                                        Plucker collection
                                                                    </TableCell>
                                                                    <TableCell align="center" colSpan="4" style={{ background: "lightgreen", fontWeight: "bold" }}>
                                                                        Field collection
                                                                    </TableCell>
                                                                    <TableCell align="center" colSpan="6" style={{ background: "lightyellow", fontWeight: "bold" }}>
                                                                        Factory collection
                                                                    </TableCell>
                                                                </TableRow>
                                                                <TableRow>
                                                                    {avialablePluckingDeductions.map((x, index) => {
                                                                        return (
                                                                            <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }} key={index}>
                                                                                {x}
                                                                            </TableCell>
                                                                        );
                                                                    })}
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Original Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Checkroll Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        No Of Bags
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Actual Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Gross Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Net Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Recieving Factory
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        No Of Bags
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Actual Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Gross Weight
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Deduction
                                                                    </TableCell>
                                                                    <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                                                        Net Weight
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody >
                                                                {reportData.map((row) => (
                                                                    <TableRow key={row.employeeCode}>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.collectionPointName == undefined ? '-' : row.collectionPointName}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.fieldName == undefined ? '-' : row.fieldName}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.pluckingOriginalWeight == undefined ? '-' : parseFloat(row.pluckingOriginalWeight).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.pluckingCheckrollWeight == undefined ? '-' : parseFloat(row.pluckingCheckrollWeight).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.fieldNoOfBags == undefined ? '-' : row.fieldNoOfBags}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.fieldActualAmount == undefined ? '-' : parseInt(row.fieldActualAmount).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.fieldGrossWeight == undefined ? '-' : parseInt(row.fieldGrossWeight).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.fieldNetWeight == undefined ? '-' : parseInt(row.fieldNetWeight).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.recievingFactory == undefined ? '-' : row.recievingFactory}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.factoryNoOfBags == undefined ? '-' : row.factoryNoOfBags}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.factoryActualAmount  == undefined ? '-' : parseFloat(row.factoryActualAmount ).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.factoryGross == undefined ? '-' : parseFloat(row.factoryGross).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.factoryMoistureDeduction == undefined ? '-' : parseFloat(row.factoryMoistureDeduction).toFixed(2)}
                                                                        </TableCell>
                                                                        <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                                                            {row.factoryNetWight == undefined ? '-' : parseFloat(row.factoryNetWight).toFixed(2)}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell colSpan="2" align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{parseFloat(totalCollections.pluckingOriginalWeight).toFixed(2)}
                                                                        {
                                                                            avialablePluckingDeductions.map((x, i) => {
                                                                                return (
                                                                                    <td key={i} style={{ textAlign: "right" }}><b>{parseFloat(totalCollections[x]).toFixed(2)}</b></td>
                                                                                );
                                                                            })
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{parseFloat(totalCollections.pluckingCheckrollWeight).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{totalCollections.fieldNoOfBags}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseInt(totalCollections.fieldActualAmount).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseInt(totalCollections.fieldGrossWeight).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseInt(totalCollections.fieldNetWeight).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalCollections.factoryNoOfBags}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryActualAmount).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryGross).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryMoistureDeduction).toFixed(2)}</TableCell>
                                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryNetWight).toFixed(2)}</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            : null}
                        </div>
                        {reportData.length != 0 ?
                            <div className="pt-2">
                                <ReactToPrint
                                    trigger={() => <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="PDF"

                                    />}
                                    content={() => componentRef.current}
                                />
                                <div hidden={true}>
                                    <CreatePdf
                                        ref={componentRef} avialablePluckingDeductions={avialablePluckingDeductions}
                                        reportData={reportData} totalCollections={totalCollections} searchData={selectedSearchValues}
                                    />
                                </div> *
                                <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div> 
                        : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
